import { ApprovalableTypeEnum } from 'api-hooks/common';
import { RefundModel } from 'api-hooks/refund/refund';
import { RefundReleaseAgentModel } from 'api-hooks/refund/refund-release-agent';
import { RefundReleaseUserModel } from 'api-hooks/refund/refund-release-user';

export default function defaultValuesRefund(
  data: RefundModel | RefundReleaseUserModel | RefundReleaseAgentModel,
  approvalableType: string,
  t: any,
) {
  const defaultValues: any = {
    id: data.id,
    status: data.status,
  };

  if (approvalableType === ApprovalableTypeEnum.Refund) {
    const temp = data as RefundModel;
    return {
      ...defaultValues,
      reason: temp.reason,
      number: temp.number,
      refId: temp.refId,
      requestedAt: temp.requestedAt,
      releaseSale: {
        number: temp.releaseSale?.sale.invoiceNumber,
        customer: `${temp.releaseSale.customer.name}${
          temp.releaseSale.customer.alias
            ? ` (${temp.releaseSale.customer.alias})`
            : ''
        } - ${temp.releaseSale.customer.phone}`,
        customerBilling: temp.releaseSale.customerBilling?.name ?? '',
        paymentMethod: t(`common:${temp.releaseSale.paymentMethod.type}`),
        paymentable: temp.releaseSale.paymentable.name,
        amount: temp.releaseSale.amount,
        total: temp.releaseSale.sale.total,
      },
      releasePurchase: temp.releasePurchase
        ? {
            number: temp.releasePurchase.purchase.number,
            agent: temp.releasePurchase.agent.name,
            amount: temp.releasePurchase.amount,
            paymentable:
              temp.releasePurchase.paymentable.chequeGiro?.name ??
              temp.releasePurchase.paymentable.name,
            paymentMethod: t(
              `common:${temp.releasePurchase.paymentMethod.type}`,
            ),
            total: temp.releasePurchase.purchase.total,
            paymentChannel:
              temp.releasePurchase.purchase.paymentChannel?.name ?? '',
          }
        : undefined,
      transactionOrderType: temp.releasePurchase?.purchase.transactionType,
      transactionSaleType: temp.releaseSale?.sale.transactionType,
    };
  }

  if (approvalableType === ApprovalableTypeEnum.ReleaseSale) {
    const temp = data as RefundReleaseUserModel;
    return {
      ...defaultValues,
      invoiceNumber: temp.sale.invoiceNumber,
      number: temp.number,
      refundAmount: temp.amount,
      reason: temp.reason,
      requestedAt: temp.requestedAt,
      paymentMethod: t(`common:${temp.paymentMethod.type}`),
      paymentable: temp.paymentable.chequeGiro?.name ?? temp.paymentable.name,
      customer: `${temp.customer.name || ''}${
        temp.customer.alias ? ` (${temp.customer.alias})` : ''
      } - ${temp.customer.phone}`,
      chequeNote: temp.paymentable.chequeGiro
        ? {
            referenceNumber: temp.paymentable.referenceNumber,
            issuedAt: temp.paymentable.issuedAt,
            expiredAt: temp.paymentable.expiredAt,
            availableAt: temp.paymentable.availableAt,
            bankAccount: `${temp.paymentable.bankAccount?.name || ''} - ${
              temp.paymentable.bankAccount?.accountNumber
            }`,
          }
        : undefined,
    };
  }

  if (approvalableType === ApprovalableTypeEnum.ReleasePurchase) {
    const temp = data as RefundReleaseAgentModel;
    return {
      ...defaultValues,
      agent: temp.agent.name,
      reason: temp.reason,
      orderNumber: temp.number,
      invoiceNumber: temp.purchase.invoiceNumber,
      paymentMethod: t(`common:${temp.paymentMethod.type}`),
      refundAmount: temp.amount,
      requestedAt: temp.requestedAt,
      paymentable: temp.paymentable.chequeGiro?.name ?? temp.paymentable.name,
      purchase: {
        transactionAt: temp.purchase.transactionAt,
        total: temp.purchase.total,
        agent: temp.purchase.agent.name,
        paymentChannel: temp.purchase.paymentChannel?.name ?? '',
        transactionType: temp.purchase.transactionType,
      },
      chequeNote: temp.paymentable.chequeGiro
        ? {
            referenceNumber: temp.paymentable.referenceNumber,
            issuedAt: temp.paymentable.issuedAt,
            expiredAt: temp.paymentable.expiredAt,
            availableAt: temp.paymentable.availableAt,
            bankAccountId: temp.paymentable.bankAccount.id,
          }
        : undefined,
    };
  }

  return defaultValues;
}
